<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="state?.dismissible ?? true"
  [dismissableMask]="state?.dismissible ?? true"
  [style]="{ width: '480px' }"
  styleClass="acx-confirm-dialog"
  (onHide)="onHide()"
>
  <ng-template #header>
    <div class="acx-confirm-dialog__header">
      <div class="acx-confirm-dialog__icon-wrap">
        <i [class]="iconClass"></i>
      </div>
      <span class="acx-confirm-dialog__title">{{ state?.title }}</span>
    </div>
  </ng-template>

  <p class="acx-confirm-dialog__message">{{ state?.message }}</p>

  <ng-template #footer>
    <div class="acx-confirm-dialog__footer">
      @if (state?.rejectVisible) {
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="reject()">
          {{ state?.cancelLabel }}
        </button>
      }
      @if (state?.acceptVisible) {
        <button type="button" class="btn btn-sm btn-primary" (click)="accept()">
          {{ state?.yesLabel }}
        </button>
      }
    </div>
  </ng-template>
</p-dialog>
